<template>
  <section class="bar-top-page px-4">
    <div class="bar-top-page-row">
      <div class="bar-top-page-left">
        <ArrowLeftBack v-if="showBackIcon" />
        <h3 class="h3 text-primary font-semi-bold m-0">{{ title }}</h3>
      </div>
      <div class="bar-top-page-right">
        <slot name="right-area"></slot>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowLeftBack from "@/components/General/ArrowLeftBack";

export default {
  name: "TopBarTitleComponent",
  components: {
    ArrowLeftBack
  },
  props: {
    title: {
      default: ""
    },
    showBackIcon: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style>
.bar-top-page {
  background: #fff;
  padding: 10px 0;
  margin-bottom: 0;
  border-bottom: 1px solid #eef1f7;
}
.bar-top-page-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 8px;
}
.bar-top-page-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: background 0.15s;
    text-decoration: none !important;
    &:hover {
      background: #f0f2f7;
      text-decoration: none !important;
    }
  }
}
.bar-top-page-left h3 {
  white-space: nowrap;
  font-size: 16px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bar-top-page-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  .btn,
  .el-button,
  .btn-delete-trigger {
    border-radius: 8px !important;
    font-size: 13px !important;
    font-weight: 600;
    padding: 0 16px !important;
    height: 36px !important;
    line-height: 36px !important;
    box-sizing: border-box;
  }
}
@media (max-width: 768px) {
  .bar-top-page {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #fff;
    border-bottom: 1px solid #e4eaf6;
    box-shadow: 0 1px 4px rgba(49, 53, 92, 0.06);
    padding: 10px 16px;
  }
  .bar-top-page-left h3 {
    font-size: 14px;
  }
  .bar-top-page-right .btn,
  .bar-top-page-right .el-button,
  .bar-top-page-right .btn-delete-trigger {
    padding: 0 12px !important;
    font-size: 12px !important;
    height: 34px !important;
    line-height: 34px !important;
    white-space: nowrap;
  }
}
</style>
